export default __webpack_public_path__ + "static/media/Die_5.89009dcc.png";